import { BrandRendererComponent } from '@components/table-column-renderer/brand-renderer.component';
import { ButtonDetailModelsComponent } from '@components/button/tables/models/button-modify-models.component';
import { ButtonDeleteModelsComponent } from '@components/button/tables/models/button-delete-models.component';

export class ModelsSettings {
  public static gridSettings() {
    return {
      actions: false,
      noDataMessage: 'Nessun dato trovato',
      attr: {
        class: 'table table-bordered',
      },
      pager: {
        display: true,
        perPage: 25,
      },
      columns: {
        detailButton: {
          type: 'custom',
          renderComponent: ButtonDetailModelsComponent,
          editable: false,
          addable: false,
          filter: false,
          width: '50px',
        },
        deleteButton: {
          type: 'custom',
          renderComponent: ButtonDeleteModelsComponent,
          editable: false,
          addable: false,
          filter: false,
          width: '50px',
        },
        id: {
          title: 'Id',
          width: '70px',
        },
        marca: {
          title: 'Marca',
          type: 'custom',
          renderComponent: BrandRendererComponent,
          width: '120px',
          filter: {
            type: 'list',
            config: {
              list: [],
            },
          },
          filterFunction(cell?: any, search?: string): boolean {
            return cell.id == search;
          },
        },
        siglaModello: {
          title: 'Sigla Modello',
        },
        descrizioneModello: {
          title: 'Descrizione Modello',
        },
        enabled: {
          title: 'Abilitato',
          width: '130px',
          valuePrepareFunction: (abilitato) => {
            if (abilitato) {
              return 'Si';
            } else {
              return 'No';
            }
          },
          filter: {
            type: 'list',
            config: {
              list: [
                { value: true, title: 'Si' },
                { value: false, title: 'No' },
              ],
            },
          },
        },
      },
      delete: null,
    };
  }
}
